import { Flex, Modal, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const VatExemptionMentionInfoModalBody = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal.Body>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Text variant="bodyMD">
          {t('external_invoices.editor.summary.vat_exemption_mention_info.modal.body.description')}
        </Text>
        <Space size="s8" />
        <Text variant="bodyLG" weight="semiBold">
          {t('external_invoices.editor.summary.vat_exemption_mention_info.modal.body.scheme_drives.title')}
        </Text>

        <Trans
          i18nKey="external_invoices.editor.summary.vat_exemption_mention_info.modal.body.scheme_drives.list"
          components={{
            ol: <Styled.VatExemptionMentionSchemeDrivesList />,
            li: <li />,
            strong: <Text as="span" weight="bold" />,
          }}
        />
        <Space size="s8" />
        <Text variant="bodyLG" weight="semiBold">
          {t('external_invoices.editor.summary.vat_exemption_mention_info.modal.body.mention.title')}
        </Text>

        <Styled.VatExemptionMentionOnInvoice>
          <Text>{t('external_invoices.editor.summary.vat_exemption_mention_info.modal.body.mention.description')}</Text>
        </Styled.VatExemptionMentionOnInvoice>

        <Text variant="bodySM" colorVariant="discreet">
          {t('external_invoices.editor.summary.vat_exemption_mention_info.modal.body.mention.note')}
        </Text>
      </Flex>
    </Modal.Body>
  )
}
